/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, details: NonNullable<unknown> }} Orders_Estes_Booking_FailedInputs */

const en_orders_estes_booking_failed = /** @type {(inputs: Orders_Estes_Booking_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`LTL booking failed for ${i?.count} order(s)${i?.details}`)
};

const es_orders_estes_booking_failed = /** @type {(inputs: Orders_Estes_Booking_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fallo la reserva LTL para ${i?.count} pedido(s)${i?.details}`)
};

/**
* | output |
* | --- |
* | "LTL booking failed for {count} order(s){details}" |
*
* @param {Orders_Estes_Booking_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_estes_booking_failed = /** @type {((inputs: Orders_Estes_Booking_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Estes_Booking_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_estes_booking_failed(inputs)
	return es_orders_estes_booking_failed(inputs)
});